exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom[data-v-0db91dd1]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:5;background:#fff}.media-zoom__close[data-v-0db91dd1]{position:absolute;right:-54px;top:-36px;z-index:1}@media screen and (max-width: 900px){.media-zoom__close[data-v-0db91dd1]{top:0;right:-16px}}", ""]);

// exports
